export default {_name:'image.avatar.edit',module:'Field',view:'Element/Image/AvatarEdit',options:{key:'avatar',sm:2,xs:12,ms:2}}